import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from './feature-flag.service';
import { inject } from '@angular/core';

// Allows the route only when the feature flag is enabled; otherwise redirects (default: the app root)
export function featureFlagGuard(key: string, redirectTo = '/'): CanActivateFn {
  return () => {
    if (inject(FeatureFlagService).isEnabled(key)) {
      return true;
    }

    return inject(Router).parseUrl(redirectTo);
  };
}
